import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brackets-angle', 'BracketsAngle', [["path",{"d":"M8 4l-5 8l5 8","key":"svg-0"}],["path",{"d":"M16 4l5 8l-5 8","key":"svg-1"}]]);